module.exports = require("object-assign");


//////////////////
// WEBPACK FOOTER
// external "object-assign"
// module id = 36
// module chunks = 0